import { render, staticRenderFns } from "./books-editor.vue?vue&type=template&id=57c21b8b"
import script from "./books-editor.vue?vue&type=script&lang=js"
export * from "./books-editor.vue?vue&type=script&lang=js"
import style0 from "./books-editor.vue?vue&type=style&index=0&id=57c21b8b&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports